import React from 'react';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export default ({ courseID }) => (
  <Button as={Link} to={`/${courseID}/myConversations`} primary>
    My sessions
  </Button>
);
